module.exports = __webpack_public_path__ + "images/BebasNeue-webfont_6f04d3d6e28184a5ace603e80b97433e.woff";